import React from "react";
import moment from "moment";

const ProfileSubmittedCard = ({ data }) => {
   
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
   {/************************************ Profile submitted card ************************************************/ }
   return (
      <div>
         <div>
            {/* <strong>Congratulations!</strong> */}
            { userProfile?.Professions?.ProfessionCode == 'HC' ? 
             <p> Great! You’ve successfully submitted the candidate’s profile to the facility on:</p> :
             <p> Success! Let's schedule the interview! </p> 

            }
         </div>
         { userProfile?.Professions?.ProfessionCode == 'HC' && 
         <div style={{ background: '#fff', padding: '2.5%', borderRadius: '5px' }}>
            <div className='dateText'>
               {moment(data?.Created).format("dddd, MMMM DD, YYYY")}
               {/* .utc */}
            </div>
            <span>
               {moment(data?.Created).format("h:mm A")}</span>
         </div> }
      </div>
   )
}
export default ProfileSubmittedCard